import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Row, Input, Button, Card, CardBody, CustomInput } from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_GM_Settings_Create, API_Ingetration } from '../../../../../../constants/APIs';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { NotificationManager } from '../../../../../../components/common/react-notifications';


const Reservation = ({ propertyId, timeZone, initialData, userName }) => {
    const [dataSource, setDataSource] = useState('CsvUploadAndManual');
    const [pms, setpms] = useState('None');
    const [syncEnabled, setSyncEnabled] = useState(false);
    const [schedule, setSchedule] = useState([]);
    const [notifyEnabled, setNotifyEnabled] = useState(false);
    const [notifyTypes, setNotifyTypes] = useState({ arrived: false, departed: false, cancelled: false, confirmed: true, unconfirmed: true });
    const [daysBeforeCheckIn, setDaysBeforeCheckIn] = useState(1);
    const [deleteAfterDays, setDeleteAfterDays] = useState(1);
    const [archiveDaysAfterDeparture, setArchiveDaysAfterDeparture] = useState(1)

    const TIME_OPTIONS = Array.from({ length: 24 }, (_, idx) => `${idx.toString().padStart(2, '0')}:00`);
    const [selectedScheduleTime, setSelectedScheduleTime] = useState(TIME_OPTIONS[0]);

    const [reservationFields, setReservationFields] = useState({
        checkin: true,
        checkout: true,
        adults: true,
        children: true,
        source: false,
        status: false,
        rateplan: false,
    });

    const [guestFields, setGuestFields] = useState({
        firstName: true,
        lastName: true,
        phone: true,
        email: true
    });

    const [updateReservation, setUpdateReservation] = useState({
        trace: false,
        message: false,
        regcard: false,
        upsell: false
    });

    const [loading, setLoading] = useState(false);
    const [scheduleError, setScheduleError] = useState("");

    const [pmsIntegrations, setPmsIntegrations] = useState([]);
    const [pmsIntegrationId, setPmsIntegrationId] = useState(null);
    const savedIntegrationIdRef = useRef(null);

    const boundedNumber = (val, min, max) => {
        const n = Number(val || 0);
        if (Number.isNaN(n)) return min;
        return Math.min(Math.max(n, min), max);
    };

    const addSchedule = () => {
        if (!selectedScheduleTime) {
            return;
        }
        setScheduleError("");

        // Max 3 schedules allowed
        if (schedule.length >= 3) {
            setScheduleError("You can add a maximum of 3 schedules.");
            return;
        }

        // Duplicate schedule time check
        if (schedule.includes(selectedScheduleTime)) {
            setScheduleError("This time is already added.");
            return;
        }

        setSchedule((s) => [...s, selectedScheduleTime]);
    };


    const removeSchedule = (idx) => setSchedule((s) => s.filter((_, i) => i !== idx));


    const Check = ({ id, label, checked, onChange, className, disabled }) => (
        <CustomInput
            type="checkbox"
            id={id}
            label={label}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            className={className || 'mb-2'}
        />
    );

    const validate = () => {
        if (dataSource !== 'CsvUploadAndManual' && dataSource !== 'PmsSync') {
            NotificationManager.error('Please select a reservation data source', 'Error', 3000);
            return false;
        }
        if (dataSource === 'PmsSync' && pms === 'None') {
            NotificationManager.error('Please select a PMS type (RMS or Oracle)', 'Error', 3000);
            return false;
        }

        return true;
    };


    const buildPayload = (selectedDataSource = dataSource, selectedpms = pms) => {
        const groupId = getGroupID();
        const todayIso = new Date().toISOString().split('T')[0];
        const syncSchedules = schedule.map((t) => {
            const [hh = '00', mm = '00'] = String(t).split(':');
            return { dateTime: `${todayIso}T${hh}:${mm}:00` };
        });
        const isCsvUpload = selectedDataSource === 'CsvUploadAndManual';
        const isPmsSync = selectedDataSource === 'PmsSync';
        const isRmsCloud = isPmsSync && selectedpms === 'RMS';
        const isOracleOpera = isPmsSync && selectedpms === 'OracleOpera';

        const finalNotify = notifyEnabled
            ? notifyTypes
            : { arrived: false, departed: false, cancelled: false };

        return {
            groupId,
            propertyId,
            dataSource: selectedDataSource,
            pms: selectedpms,
            timeZone,
            pmsIntegrationId: pmsIntegrationId,
            syncEnabled,
            receiveStatusNotification: notifyEnabled,
            arrived: finalNotify.arrived,
            departed: finalNotify.departed,
            cancelled: finalNotify.cancelled,
            confirmed: finalNotify.confirmed,
            unconfirmed: finalNotify.unconfirmed,
            syncDaysBeforeCheckin: daysBeforeCheckIn,
            deleteDaysAfterDeparture: deleteAfterDays,
            archiveDaysAfterDeparture: archiveDaysAfterDeparture,
            checkIn: reservationFields.checkin,
            checkOut: reservationFields.checkout,
            adults: reservationFields.adults,
            children: reservationFields.children,
            source: reservationFields.source,
            status: reservationFields.status,
            ratePlanWithPolicies: reservationFields.rateplan,
            firstName: guestFields.firstName,
            lastName: guestFields.lastName,
            phone: guestFields.phone,
            email: guestFields.email,
            trace: updateReservation.trace,
            message: updateReservation.message,
            regCard: updateReservation.regcard,
            upsell: updateReservation.upsell,
            syncSchedules,
            createdBy: userName,
        };
    };

    const VALID_DATA_SOURCES = ['CsvUploadAndManual', 'PmsSync'];
    const VALID_PMS_TYPES = ['RMS', 'OracleOpera'];

    const hydrateFromResponse = (res) => {
        if (!res) return;
        const responseDataSource = typeof res.dataSource === 'string' ? res.dataSource : null;
        if (responseDataSource && VALID_DATA_SOURCES.includes(responseDataSource)) {
            setDataSource(responseDataSource);
        } else if (res.pmsSync) {
            setDataSource('PmsSync');
        } else if (res.csvUploadAndManual) {
            setDataSource('CsvUploadAndManual');
        } else {
            setDataSource('CsvUploadAndManual');
        }

        const responsepms = typeof res.pms === 'string' ? res.pms : null;
        if (responsepms && VALID_PMS_TYPES.includes(responsepms)) {
            setpms(responsepms);
        } else if (res.rmsCloud) {
            setpms('RMS');
        } else if (res.oracleOperaCloud) {
            setpms('OracleOpera');
        } else {
            setpms('None');
        }
        setSyncEnabled(!!res.syncEnabled);
        setNotifyEnabled(!!res.receiveStatusNotification);
        setNotifyTypes({
            arrived: !!res.arrived,
            departed: !!res.departed,
            cancelled: !!res.cancelled,
            confirmed: res.Confirmed !== undefined ? !!res.Confirmed : true,
            unconfirmed: res.Unconfirmed !== undefined ? !!res.Unconfirmed : true,
        });
        setDaysBeforeCheckIn(Number(res.syncDaysBeforeCheckin) || 1);
        setDeleteAfterDays(Number(res.deleteDaysAfterDeparture) || 1);
        setArchiveDaysAfterDeparture(Number(res.archiveDaysAfterDeparture) || 1)
        setReservationFields({
            checkin: res.checkIn !== undefined ? !!res.checkIn : true,
            checkout: res.checkOut !== undefined ? !!res.checkOut : true,
            adults: res.adults !== undefined ? !!res.adults : true,
            children: res.children !== undefined ? !!res.children : true,
            source: !!res.source,
            status: !!res.status,
            rateplan: !!res.ratePlanWithPolicies,
        });
        setGuestFields({
            firstName: res.firstName !== undefined ? !!res.firstName : true,
            lastName: res.lastName !== undefined ? !!res.lastName : true,
            phone: res.phone !== undefined ? !!res.phone : true,
            email: res.email !== undefined ? !!res.email : true,
        });
        setUpdateReservation({
            trace: !!res.trace,
            message: !!res.message,
            regcard: !!res.regCard,
            upsell: !!res.upsell,
        });
        const sched = Array.isArray(res.syncSchedules)
            ? res.syncSchedules
                .map((s) => s.dateTime)
                .filter(Boolean)
                .map((value) => {
                    const stringVal = String(value);
                    if (/^\d{1,2}:\d{2}$/.test(stringVal)) {
                        const [hh, mm] = stringVal.split(':');
                        return `${hh.padStart(2, '0')}:${mm}`;
                    }
                    const d = new Date(stringVal);
                    if (Number.isNaN(d.getTime())) return stringVal;
                    const hh = d.getHours().toString().padStart(2, '0');
                    const mm = d.getMinutes().toString().padStart(2, '0');
                    return `${hh}:${mm}`;
                })
            : [];
        setSchedule(sched);
        if (res.pmsIntegrationId !== undefined && res.pmsIntegrationId !== null) {
            const id = String(res.pmsIntegrationId);
            savedIntegrationIdRef.current = id;
            setPmsIntegrationId(id);
        } else {
            savedIntegrationIdRef.current = null;
            setPmsIntegrationId(null);
        }
    };

    useEffect(() => {
        if (initialData) {
            hydrateFromResponse(initialData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialData]);


    const resolveSelections = () => {
        let resolvedDataSource = dataSource;
        let resolvedpms = pms;

        const isKnownDataSource = VALID_DATA_SOURCES.includes(resolvedDataSource);

        if (!isKnownDataSource) {
            resolvedDataSource = 'CsvUploadAndManual';
            resolvedpms = 'None';
        } else if (resolvedDataSource === 'PmsSync' && resolvedpms === 'None') {
            resolvedDataSource = 'CsvUploadAndManual';
            resolvedpms = 'None';
        }

        return { resolvedDataSource, resolvedpms };
    };

    const handleSave = async () => {
        if (!validate()) return;
        const { resolvedDataSource, resolvedpms } = resolveSelections();

        if (resolvedDataSource !== dataSource) setDataSource(resolvedDataSource);
        if (resolvedpms !== pms) setpms(resolvedpms);

        const payload = buildPayload(resolvedDataSource, resolvedpms);
        setLoading(true);
        try {
            await AxiosAPI({
                method: 'post',
                url: `${postAPI_GM_Settings_Create}`,
                data: payload,
            });
            NotificationManager.success('Added Successfully', 'Success', 3000);

        } catch (err) {
            console.error('Error saving:', err);
        } finally {
            setLoading(false);
            setScheduleError("");
        }
    };
    const fetchPmsIntegrations = async (type) => {
        if (!propertyId || !VALID_PMS_TYPES.includes(type)) return [];

        const groupId = getGroupID();
        const channel = type === 'RMS' ? 'RMSBookingEngine' : 'OracleOpera';

        try {
            const res = await AxiosAPI({
                method: 'post',
                url: `${API_Ingetration}?group_id=${groupId}`,
                data: { Channels: [channel] },
            });

            const filtered = res.data.filter((item) => item.properties?.includes(propertyId));

            return filtered.map((i) => ({
                label: i.name,
                value: String(i.id),
            }));
        } catch (e) {
            console.error('PMS Integration error:', e);
            return [];
        }
    };

    useEffect(() => {
        let isMounted = true;

        const loadIntegrations = async () => {
            if (dataSource !== 'PmsSync' || !VALID_PMS_TYPES.includes(pms)) {
                setPmsIntegrations([]);
                setPmsIntegrationId(null);
                return;
            }

            const items = await fetchPmsIntegrations(pms);
            if (!isMounted) return;

            setPmsIntegrations(items);

            const desiredId = savedIntegrationIdRef.current || pmsIntegrationId;
            if (desiredId) {
                const desiredIdStr = String(desiredId);
                const match = items.find((item) => String(item.value) === desiredIdStr);
                if (match) {
                    savedIntegrationIdRef.current = desiredIdStr;
                    setPmsIntegrationId(desiredIdStr);
                    return;
                }
            }

            savedIntegrationIdRef.current = null;
            setPmsIntegrationId(null);
        };

        loadIntegrations();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource, pms, propertyId]);


    return (
        <Fragment>
            <Row>
                <Colxx lg="12" className="mb-2">
                    <Card>
                        <CardBody>
                            {loading ? (
                                <div className="loading" />
                            ) : (
                                <Fragment>
                                    {/* Reservation Source */}
                                    <h6 className="mb-3"><b>Reservation Data Source</b></h6>
                                    <Check
                                        id="csv-upload"
                                        label="CSV Upload and Manual Entry"
                                        checked={dataSource === 'CsvUploadAndManual'}
                                        onChange={() => {
                                            setDataSource((prev) => (prev === 'CsvUploadAndManual' ? 'None' : 'CsvUploadAndManual'));
                                            setpms('None');
                                        }}
                                    />
                                    <Check
                                        id="pms-sync"
                                        label="PMS Sync"
                                        checked={dataSource === 'PmsSync'}
                                        onChange={() => {
                                            if (dataSource === 'PmsSync') {
                                                setDataSource('None');
                                                setpms('None');
                                            } else {
                                                setDataSource('PmsSync');
                                                if (!VALID_PMS_TYPES.includes(pms)) {
                                                    setpms('None');
                                                }
                                            }
                                        }}
                                    />

                                    {dataSource === 'PmsSync' && (
                                        <Fragment>
                                            <div className="ml-4">
                                                <Check
                                                    id="rms-cloud"
                                                    label="RMS Cloud"
                                                    checked={pms === 'RMS'}
                                                    onChange={() => {
                                                        setDataSource('PmsSync');
                                                        const newValue = pms === 'RMS' ? 'None' : 'RMS';
                                                        setpms(newValue);
                                                    }}
                                                />
                                                <Check
                                                    id="oracle-opera"
                                                    label="Oracle Opera Cloud"
                                                    checked={pms === 'OracleOpera'}
                                                    onChange={() => {
                                                        setDataSource('PmsSync');
                                                        const newValue = pms === 'OracleOpera' ? 'None' : 'OracleOpera';
                                                        setpms(newValue);
                                                    }}
                                                />
                                            </div>

                                            {dataSource === "PmsSync" && pms !== "None" && (


                                                <div className="mt-2">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <Input className='input_sty'
                                                            type="select"
                                                            value={pmsIntegrationId ?? ""}
                                                            style={{
                                                                width: "220px"
                                                            }}
                                                            onChange={e => {
                                                                const newValue = e.target.value || null;
                                                                savedIntegrationIdRef.current = newValue;
                                                                setPmsIntegrationId(newValue);
                                                            }}
                                                        >
                                                            <option value="">Select Integration</option>
                                                            {pmsIntegrations.map((i) => (
                                                                <option key={i.value} value={i.value}>{i.label}</option>
                                                            ))}
                                                        </Input>
                                                    </div>
                                                </div>

                                            )}
                                        </Fragment>
                                    )}


                                    {dataSource === "PmsSync" && (
                                        <Fragment>
                                            <Separator className="mt-3 mb-3" />
                                            <h6 className="mb-2"><b>Setup PMS Sync</b></h6>
                                            <Check
                                                id="sync-enabled"
                                                label="Sync frequency (min 1 time a day, max 3 times a day)"
                                                checked={syncEnabled}
                                                onChange={() => setSyncEnabled(!syncEnabled)}
                                            />

                                            {syncEnabled && (
                                                <Fragment>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <span className="mr-2"><b>Timezone:</b> {timeZone}</span>
                                                    </div>
                                                    <div className="mt-2">
                                                        <div className="d-flex align-items-center mb-2">
                                                            <span className="mr-2">Time</span>
                                                            <Input className='input_sty'
                                                                type="select"
                                                                value={selectedScheduleTime}
                                                                onChange={(e) => setSelectedScheduleTime(e.target.value)}
                                                                style={{ maxWidth: 120 }}
                                                            >
                                                                {TIME_OPTIONS.map((time) => (
                                                                    <option key={time} value={time}>
                                                                        {time}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            {scheduleError && (
                                                                <span style={{ color: "red", marginLeft: "10px", fontSize: "12px" }}>
                                                                    {scheduleError}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <Button color="primary" size="xs" outline onClick={addSchedule}>+ Add Schedule</Button>
                                                        {schedule.length > 0 && (
                                                            <div className="mt-2">
                                                                {schedule.map((t, idx) => (
                                                                    <div key={`${t}-${idx}`} className="d-flex align-items-center mb-1">
                                                                        <span className="mr-2">{t}</span>
                                                                        <Button color="link" size="sm" onClick={() => removeSchedule(idx)}>Remove</Button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </Fragment>
                                            )}
                                        </Fragment>
                                    )}
                                    <Separator className="mt-3 mb-3" />

                                    {dataSource === "PmsSync" && (
                                        <Fragment>
                                            <Check
                                                id="notify-enabled"
                                                label="Receive reservation status notification"
                                                checked={notifyEnabled}
                                                onChange={() => setNotifyEnabled(!notifyEnabled)}
                                            />
                                            {notifyEnabled && (
                                                <div className="ml-4 mt-1">
                                                    <Check id="notify-arrived" label="Arrived" checked={notifyTypes.arrived} onChange={() => setNotifyTypes({ ...notifyTypes, arrived: !notifyTypes.arrived })} />
                                                    <Check id="notify-departed" label="Departed" checked={notifyTypes.departed} onChange={() => setNotifyTypes({ ...notifyTypes, departed: !notifyTypes.departed })} />
                                                    <Check id="notify-cancelled" label="Cancelled" checked={notifyTypes.cancelled} onChange={() => setNotifyTypes({ ...notifyTypes, cancelled: !notifyTypes.cancelled })} />
                                                    <Check id="notify-confirmed" label="Confirmed" disabled checked={notifyTypes.confirmed} onChange={() => setNotifyTypes({ ...notifyTypes, confirmed: !notifyTypes.confirmed })} />
                                                    <Check id="notify-unconfirmed" label="Unconfirmed" disabled checked={notifyTypes.unconfirmed} onChange={() => setNotifyTypes({ ...notifyTypes, unconfirmed: !notifyTypes.unconfirmed })} />
                                                </div>
                                            )}
                                        </Fragment>
                                    )}
                                    <Row className="mt-3">
                                        {dataSource === "PmsSync" && (
                                            <Colxx md="6" className="mb-2 d-flex align-items-center">
                                                <span className="mr-2">Sync data</span>
                                                <Input className='input_sty' style={{ maxWidth: 90 }} type="number" min={1} max={30} value={daysBeforeCheckIn} onChange={(e) => setDaysBeforeCheckIn(boundedNumber(e.target.value, 1, 30))} />
                                                <span className="ml-2">days before check-in</span>
                                            </Colxx>
                                        )}

                                        <Colxx md="6" className="mb-2 d-flex align-items-center">
                                            <span className="mr-2"> Remove from Active Reservations</span>
                                            <Input className='input_sty' style={{ maxWidth: 90 }} type="number" min={1} max={30} value={archiveDaysAfterDeparture} onChange={(e) => setArchiveDaysAfterDeparture(boundedNumber(e.target.value, 1, 30))} />
                                            <span className="ml-2">days after departure</span>
                                        </Colxx>

                                        <Colxx md="6" className="mb-2 d-flex align-items-center">
                                            <span className="mr-2">Permanently delete data</span>
                                            <Input className='input_sty' style={{ maxWidth: 90 }} type="number" min={1} max={30} value={deleteAfterDays} onChange={(e) => setDeleteAfterDays(boundedNumber(e.target.value, 1, 30))} />
                                            <span className="ml-2">days after departure</span>
                                        </Colxx>
                                    </Row>

                                    <Separator className="mt-3 mb-3" />
                                    <Row className="mt-3">
                                        <Colxx md="4" className="mb-2 align-items-center">
                                            <h6 className="mb-2"><b>Choose reservation fields</b></h6>
                                            {Object.keys(reservationFields).map((key, index) => {
                                                const isDisabled = index < 4; // First 4 fields: checkin, checkout, adults, children
                                                return (
                                                    <Check
                                                        key={key}
                                                        id={`rf-${key}`}
                                                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                                                        checked={reservationFields[key]}
                                                        disabled={isDisabled}
                                                        onChange={() =>
                                                            !isDisabled && setReservationFields({ ...reservationFields, [key]: !reservationFields[key] })
                                                        }
                                                    />
                                                );
                                            })}
                                        </Colxx>
                                        <Colxx md="4" className="mb-2 align-items-center">
                                            <h6 className="mb-2"><b>Choose guest fields</b></h6>
                                            {Object.keys(guestFields).map((key) => {
                                                const isDisabled = true; // All guest fields are disabled
                                                return (
                                                    <Check
                                                        key={key}
                                                        id={`gf-${key}`}
                                                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                                                        checked={guestFields[key]}
                                                        disabled={isDisabled}
                                                        onChange={() =>
                                                            !isDisabled && setGuestFields({ ...guestFields, [key]: !guestFields[key] })
                                                        }
                                                    />
                                                );
                                            })}
                                        </Colxx>
                                        {dataSource === 'PmsSync' && (
                                            <Colxx md="4" className="mb-2 align-items-center">
                                                <h6 className="mb-2"><b>Update reservation</b></h6>
                                                {Object.keys(updateReservation).map((key) => (
                                                    <Check
                                                        key={key}
                                                        id={`upd-${key}`}
                                                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                                                        checked={updateReservation[key]}
                                                        onChange={() =>
                                                            setUpdateReservation({ ...updateReservation, [key]: !updateReservation[key] })
                                                        }
                                                    />
                                                ))}
                                            </Colxx>
                                        )}
                                    </Row>


                                    {/* Save Button */}
                                    <div className="mt-4 text-right">
                                        <Button color="primary" size="xs" outline onClick={handleSave} disabled={loading}>
                                            Save
                                        </Button>
                                    </div>
                                </Fragment>
                            )}
                        </CardBody>
                    </Card>
                </Colxx>
            </Row>
        </Fragment>
    );
};

const mapStateToProps = ({ settings }) => {
    const { propertyId, timeZone, userName, } = settings;
    return { propertyId, timeZone, userName, };
};

export default injectIntl(connect(mapStateToProps, {})(Reservation));
